// main.ts
import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

// Importar y registrar los web components de Ionic
import { defineCustomElements } from "@ionic/core/loader";

// Registrar los custom elements
defineCustomElements(window);

// Activar modo producción si aplica
if (environment.production) {
  enableProdMode();
}

// Bootstrap de Angular
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
